var map = {
	"./queries/product/CatalogRelated": 419,
	"./queries/product/CatalogRelated.gql": 419,
	"./queries/product/Product": 446,
	"./queries/product/Product.gql": 446,
	"./queries/product/ProductRelated": 447,
	"./queries/product/ProductRelated.gql": 447,
	"./queries/product/ProductsSearch": 420,
	"./queries/product/ProductsSearch.gql": 420,
	"./queries/product/SimilarProducts": 448,
	"./queries/product/SimilarProducts.gql": 448,
	"./queries/product/SuggestedProducts": 413,
	"./queries/product/SuggestedProducts.gql": 413,
	"./queries/product/Suggestions": 415,
	"./queries/product/Suggestions.gql": 415,
	"./queries/taxonomy/Brands": 412,
	"./queries/taxonomy/Brands.gql": 412,
	"./queries/taxonomy/Categories": 421,
	"./queries/taxonomy/Categories.gql": 421,
	"./queries/taxonomy/Taxonomy": 304,
	"./queries/taxonomy/Taxonomy.gql": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;